import React from 'react';
import PropTypes from 'prop-types';

import HoursList from './HoursList';

export function FacilityHours({ accessHours, officeHours }) {
	return (
		<div className="facility-hours">
			<div className="hours-container">
				<HoursList
					hours={officeHours}
					listTitle="Office Hours"
				/>
				<HoursList
					hours={accessHours}
					listTitle="Access Hours"
				/>
			</div>
		</div>
	);
}

FacilityHours.propTypes = {
	accessHours: PropTypes.object.isRequired,
	officeHours: PropTypes.object.isRequired,
};

export default FacilityHours;
